import { render, staticRenderFns } from "./Qr.vue?vue&type=template&id=2bf882ca&scoped=true&"
import script from "./Qr.vue?vue&type=script&lang=js&"
export * from "./Qr.vue?vue&type=script&lang=js&"
import style0 from "./Qr.vue?vue&type=style&index=0&id=2bf882ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf882ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
